<ng-template #entryCommentsModalTemplate let-modalRef="modalRef" let-entryIndex="entryIndex">
  <div class="modal-header">
    <h4 class="modal-title" id="track-comment-modal-title">
      @if (warningToggleContext(); as warningContext) {
        @if (warningContext.currentWarningState) {
          {{ 'TRACK.COMMENTS_MODAL.REMOVE_WARNING' | translate }}
        } @else {
          {{ 'TRACK.COMMENTS_MODAL.ADD_WARNING' | translate }}
        }
        - {{ 'TRACK.COMMENTS_MODAL.COMMENT_REQUIRED' | translate }}
      } @else {
        {{ 'TRACK.COMMENTS_MODAL.HEADING' | translate }}
      }
    </h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    <!-- Only show existing comments list without any alert boxes for mandatory warning -->
    @if (modalEntryData(); as entryData) {
      @if (entryData.rowData.comments.length === 0) {
        <p class="text-info">{{ 'TRACK.COMMENTS_MODAL.NO_COMMENTS' | translate }}</p>
      } @else {
        <!-- Comment Display: improved layout -->
        <div class="comment-list">
          @for (comment of entryData.rowData.comments; track $index) {
            <div class="comment-item list-group-item">
              <div class="d-flex w-100 justify-content-between align-items-start">
                <div class="comment-content flex-grow-1">
                  <div class="comment-text">
                    <!-- Split content by lines and render with contextual classes -->
                    @for (line of formatCommentLines(comment.content); track $index) {
                      <div
                        class="comment-line"
                        [class.changes-header]="line.startsWith('Changes made:')"
                        [class.change-item]="line.includes('→')"
                        [class.comment-header]="line.startsWith('Warning') || line.startsWith('Comment:')"
                        [class.comment-text-line]="!line.startsWith('Changes made:') && !line.includes('→') && !line.startsWith('Warning') && !line.startsWith('Comment:')"
                      >
                        {{ line }}
                      </div>
                    }
                  </div>
                </div>

                <div class="d-flex align-items-start ms-3">
                  <div class="comment-metadata d-flex flex-column align-items-end me-2">
                    @if (comment.author) {
                      <div class="comment-author text-muted small fw-semibold">{{
                        comment.author
                      }}</div>
                    }
                    <div class="comment-date text-muted small">{{
                      comment.date
                        | date
                          : (translateService.getCurrentLang() === 'de'
                              ? 'dd.MM.yyyy'
                              : 'MM/dd/yyyy')
                    }}</div>
                  </div>

                  @if (selectedTrack()?.id) {
                    <i
                      class="icon element-lock ms-2"
                      title="Comment cannot be deleted after track is saved"
                    ></i>
                  } @else {
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger ms-2"
                      aria-label="Delete comment"
                      (click)="deleteComment($index, entryIndex)"
                    >
                      <i class="icon element-delete"></i>
                    </button>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
      <!-- Changes Made Section - Only show for regular comments, not warning toggles -->
      @if (currentRowChangesSummary() && !isMandatoryForWarning()) {
        <div class="mb-3">
          <span class="text small"
            >{{ 'TRACK.COMMENTS_MODAL.CHANGES_MADE' | translate }}:
            {{ currentRowChangesSummary() }}</span
          >
        </div>
      }
      <!-- Add Comment Input -->
      <form class="d-flex gap-2 mb-3" (ngSubmit)="addComment()">
        <input
          name="newCommentText"
          type="text"
          class="form-control"
          maxlength="200"
          autocomplete="off"
          [placeholder]="getCommentPlaceholder()"
          [(ngModel)]="newCommentInput"
        />
        <button type="submit" class="btn btn-primary" [disabled]="!newCommentInput().trim()">
          <i class="icon element-plus"></i>
        </button>
      </form>
    }
  </div>
</ng-template>

<!-- Comments Button to trigger the modal -->
<button
  type="button"
  role="button"
  class="btn btn-ghost btn-circle element-notes-edit action-buttons position-relative btn-lg"
  aria-label="Comments"
  [attr.data-comment-index]="entryIndex()"
  (click)="openCommentsModal(entryCommentsModalTemplate)"
>
  <!-- Amount of Comments -->
  @if (commentsCount() > 0) {
    <span class="badge bg-info position-absolute top-75 start-75 translate-middle">{{
      commentsCount()
    }}</span>
  }
</button>
